import React from 'react';

import ContentPage from '@/src/cms/components/CMSPage/Content';

const PrivacyPolicy = props => {
  return <ContentPage {...props} />;
};

export async function getStaticProps() {
  return {
    props: {
      sitepageid: 56432,
    },
  };
}

export default PrivacyPolicy;
